import { SpaceLg, SpaceMd, ColorGray500, SpaceXxs, SpaceSm } from "@nxt-costco-com/forge-design-tokens";
const UserInfoContainerSx = {
  borderBottom: `1px solid ${ColorGray500}`,
  padding: `${SpaceLg} ${SpaceMd} ${SpaceMd} ${SpaceMd}`
};
const BottomInfoContainerSx = {
  alignItems: "flex-start",
  display: "flex",
  gap: SpaceSm,
  justifyContent: "flex-start",
  marginTop: SpaceXxs
};
const BottomTextContainerSx = {
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start"
};
const CardImageSx = {
  marginTop: SpaceXxs,
  width: "50px"
};
export {
  BottomInfoContainerSx,
  BottomTextContainerSx,
  CardImageSx,
  UserInfoContainerSx
};
